// extracted by mini-css-extract-plugin
export default {"container":"MarkdownInfo_container__Od-DS","content":"MarkdownInfo_content__ktU+m","header":"MarkdownInfo_header__5axSB"};